/* eslint-disable max-len */
import React from 'react';

export default function PodcastIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      fill="none"
      viewBox="0 0 52 52"
    >
      <path
        fill="url(#paint0_linear_10353_4367)"
        d="M4.369 48.879L1.506 51.74a.882.882 0 11-1.248-1.248l2.863-2.862a.882.882 0 111.248 1.248z"
      />
      <path
        fill="url(#paint1_linear_10353_4367)"
        d="M4.369 48.879L1.506 51.74a.882.882 0 11-1.248-1.248l2.863-2.862a.882.882 0 111.248 1.248z"
      />
      <path
        fill="url(#paint2_linear_10353_4367)"
        d="M4.115 50.285l-2.4-2.4a3.079 3.079 0 01-.163-4.18l20.289-23.71 10.164 10.164-23.71 20.288a3.079 3.079 0 01-4.18-.162z"
      />
      <path
        fill="url(#paint3_linear_10353_4367)"
        d="M18.965 41.317l13.04-11.158-10.164-10.165-11.158 13.04 8.282 8.283z"
      />
      <path
        fill="url(#paint4_linear_10353_4367)"
        d="M12.028 47.252l-7.28-7.28-3.196 3.734a3.079 3.079 0 00.163 4.178l2.4 2.401a3.079 3.079 0 004.18.163l3.733-3.196z"
      />
      <path
        fill="url(#paint5_linear_10353_4367)"
        d="M29.116 23.644l-.76-.76c-4.983-4.983-4.495-13.2 1.043-17.557l3.568-2.808a11.76 11.76 0 0116.514 16.513l-2.808 3.569c-4.358 5.537-12.574 6.025-17.557 1.043z"
      />
      <path
        fill="url(#paint6_linear_10353_4367)"
        d="M29.399 5.327C23.86 9.685 23.373 17.9 28.356 22.883l.76.76c4.983 4.983 13.199 4.495 17.557-1.042l.876-1.114L30.513 4.45l-1.114.877z"
      />
      <path
        fill="url(#paint7_linear_10353_4367)"
        d="M49.481 19.032A11.76 11.76 0 0046.51 1.81L27.024 21.295c.39.557.833 1.09 1.332 1.588l.76.76c4.983 4.983 13.199 4.495 17.557-1.042l2.808-3.569z"
      />
      <path
        fill="url(#paint8_linear_10353_4367)"
        d="M43.09 24.354c0-.39.317-.705.706-.705h1.399c.154 0 .296.05.413.134.375-.365.731-.758 1.065-1.182l2.268-2.882v-1.215c0-.39.316-.705.705-.705h.685a11.703 11.703 0 001.281-3.04h-1.966a.706.706 0 01-.705-.706v-1.398c0-.39.316-.706.705-.706h2.352c.016-1.023-.1-2.045-.349-3.04h-2.003a.706.706 0 01-.705-.706V6.805c0-.39.316-.706.705-.706h.903a11.754 11.754 0 00-1.994-2.655c-.804-.804-1.7-1.47-2.655-1.994v.903c0 .39-.316.706-.705.706h-1.398a.706.706 0 01-.706-.706V.351a11.804 11.804 0 00-3.04-.349v2.351c0 .39-.316.706-.706.706h-1.398a.706.706 0 01-.706-.706V.387a11.698 11.698 0 00-3.04 1.282v.684c0 .39-.316.706-.706.706h-1.214l-2.882 2.268c-.424.333-.818.69-1.182 1.065a.701.701 0 01.134.413v1.398c0 .39-.316.706-.706.706h-1.287a11.726 11.726 0 00-1.151 3.04h2.438c.39 0 .706.316.706.706v1.398c0 .39-.316.706-.706.706h-2.732c.016 1.023.165 2.046.447 3.04h2.285c.39 0 .706.316.706.706v1.398c0 .39-.316.706-.706.706h-1.068a11.81 11.81 0 001.78 2.274l.76.76c.7.701 1.465 1.294 2.274 1.78v-1.069c0-.39.316-.705.706-.705h1.398c.39 0 .706.316.706.705v2.285c.994.283 2.017.431 3.04.447v-2.731c0-.39.316-.706.706-.706h1.398c.39 0 .706.316.706.706v2.438a11.73 11.73 0 003.04-1.151v-1.288zM33.426 8.91h-1.258a.776.776 0 01-.776-.776V6.875c0-.428.347-.776.776-.776h1.258c.429 0 .776.348.776.776v1.258a.776.776 0 01-.776.776zm0 5.85h-1.258a.776.776 0 01-.776-.776v-1.258c0-.429.347-.776.776-.776h1.258c.429 0 .776.347.776.776v1.258a.776.776 0 01-.776.776zm5.85-5.85h-1.258a.776.776 0 01-.776-.776V6.875c0-.428.347-.776.776-.776h1.258c.428 0 .776.348.776.776v1.258a.776.776 0 01-.776.776zm-5.85 11.7h-1.258a.776.776 0 01-.776-.776v-1.259c0-.428.347-.775.776-.775h1.258c.429 0 .776.347.776.775v1.259a.776.776 0 01-.776.776zm5.85-5.85h-1.258a.776.776 0 01-.776-.776v-1.258c0-.429.347-.776.776-.776h1.258c.428 0 .776.347.776.776v1.258a.776.776 0 01-.776.776zm5.85-5.85h-1.259a.776.776 0 01-.775-.776V6.875c0-.428.347-.776.775-.776h1.259c.428 0 .775.348.775.776v1.258a.776.776 0 01-.775.776zm-5.85 11.7h-1.258a.776.776 0 01-.776-.776v-1.259c0-.428.347-.775.776-.775h1.258c.428 0 .776.347.776.775v1.259a.776.776 0 01-.776.776zm5.85-5.85h-1.259a.776.776 0 01-.775-.776v-1.258c0-.429.347-.776.775-.776h1.259c.428 0 .775.347.775.776v1.258a.776.776 0 01-.775.776zm0 5.85h-1.259a.776.776 0 01-.775-.776v-1.259c0-.428.347-.775.775-.775h1.259c.428 0 .775.347.775.775v1.259a.776.776 0 01-.775.776z"
      />
      <path
        fill="url(#paint9_linear_10353_4367)"
        d="M30.022 41.339L10.661 21.978a2.718 2.718 0 010-3.844l7.47-7.47a2.718 2.718 0 013.844 0l19.36 19.361a2.718 2.718 0 010 3.844l-7.469 7.47a2.718 2.718 0 01-3.844 0z"
      />
      <path
        fill="url(#paint10_linear_10353_4367)"
        d="M17.492 11.303l-6.831 6.831a2.718 2.718 0 000 3.844l19.36 19.361a2.718 2.718 0 003.845 0l6.831-6.831-23.205-23.206z"
      />
      <path
        fill="url(#paint11_linear_10353_4367)"
        d="M41.335 30.026l-8.548-8.549-11.313 11.314 8.548 8.548a2.718 2.718 0 003.844 0l7.47-7.47a2.718 2.718 0 000-3.843z"
      />
      <path
        fill="url(#paint12_linear_10353_4367)"
        d="M13.416 39.905l-1.322-1.32a1.454 1.454 0 010-2.056l2.606-2.606a1.453 1.453 0 012.055 0l1.322 1.321a1.453 1.453 0 010 2.056l-2.606 2.605a1.453 1.453 0 01-2.055 0z"
      />
      <path
        fill="url(#paint13_linear_10353_4367)"
        d="M13.452 35.17l-1.358 1.359a1.453 1.453 0 000 2.055l1.322 1.321a1.453 1.453 0 002.055 0l1.358-1.358-3.377-3.376z"
      />
      <path
        fill="url(#paint14_linear_10353_4367)"
        d="M15.893 38.97l-2.863-2.863a.882.882 0 111.248-1.248l2.863 2.862a.882.882 0 01-1.248 1.248z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10353_4367"
          x1="1.723"
          x2="2.677"
          y1="49.096"
          y2="50.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#384949" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10353_4367"
          x1="0.419"
          x2="3.949"
          y1="50.188"
          y2="49.253"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1A1A" stopOpacity="0" />
          <stop offset="1" stopColor="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10353_4367"
          x1="12.761"
          x2="17.584"
          y1="34.922"
          y2="39.746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#384949" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10353_4367"
          x1="17.16"
          x2="20.387"
          y1="34.84"
          y2="31.613"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1A1A" stopOpacity="0" />
          <stop offset="1" stopColor="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10353_4367"
          x1="6.909"
          x2="2.879"
          y1="45.091"
          y2="49.121"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1A1A" stopOpacity="0" />
          <stop offset="1" stopColor="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10353_4367"
          x1="29.948"
          x2="47.338"
          y1="4.655"
          y2="22.045"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#384949" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10353_4367"
          x1="34.983"
          x2="31.445"
          y1="17.01"
          y2="20.548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1A1A" stopOpacity="0" />
          <stop offset="1" stopColor="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10353_4367"
          x1="40.623"
          x2="48.219"
          y1="15.148"
          y2="21.974"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1A1A" stopOpacity="0" />
          <stop offset="1" stopColor="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10353_4367"
          x1="35.613"
          x2="41.723"
          y1="2.191"
          y2="25.806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1A1A" stopOpacity="0" />
          <stop offset="1" stopColor="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10353_4367"
          x1="29.089"
          x2="20.723"
          y1="20.463"
          y2="35.435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAF9FA" />
          <stop offset="1" stopColor="#B4D2E2" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_10353_4367"
          x1="24.084"
          x2="19.154"
          y1="27.909"
          y2="32.839"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#528FD8" stopOpacity="0" />
          <stop offset="0.219" stopColor="#4E8ED8" stopOpacity="0.219" />
          <stop offset="0.451" stopColor="#4189D6" stopOpacity="0.451" />
          <stop offset="0.69" stopColor="#2C81D3" stopOpacity="0.69" />
          <stop offset="0.931" stopColor="#0E76CF" stopOpacity="0.931" />
          <stop offset="1" stopColor="#0473CE" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_10353_4367"
          x1="34.23"
          x2="37.933"
          y1="34.229"
          y2="37.932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#528FD8" stopOpacity="0" />
          <stop offset="0.219" stopColor="#4E8ED8" stopOpacity="0.219" />
          <stop offset="0.451" stopColor="#4189D6" stopOpacity="0.451" />
          <stop offset="0.69" stopColor="#2C81D3" stopOpacity="0.69" />
          <stop offset="0.931" stopColor="#0E76CF" stopOpacity="0.931" />
          <stop offset="1" stopColor="#0473CE" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_10353_4367"
          x1="17.326"
          x2="12.575"
          y1="39.147"
          y2="34.396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#384949" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_10353_4367"
          x1="12.904"
          x2="14.68"
          y1="39.092"
          y2="37.316"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1A1A" stopOpacity="0" />
          <stop offset="1" stopColor="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_10353_4367"
          x1="15.675"
          x2="14.721"
          y1="36.321"
          y2="37.275"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#384949" />
        </linearGradient>
      </defs>
    </svg>
  );
}
